module.exports = __webpack_public_path__ + "video/1800-3_YR_2021_Disinformation.5687b8e0.vtt";